import {useParams} from "react-router-dom";
import {Cutter} from "./Cutter.tsx";

export function CutterPage() {
    const {cutterId} = useParams();
    return <Cutter cutterId={cutterId}/>;
}
